import "regenerator-runtime/runtime"
import { createClient } from "graphql-ws"
import { RelayNetworkLayer, urlMiddleware, loggerMiddleware } from "react-relay-network-modern"
import { Environment, RecordSource, Store, Observable } from "relay-runtime"

const NODE_ENV = process.env.NODE_ENV
const GRAPHQLAPI_SUBSCRIPTION_PATH = process.env.REACT_APP_GRAPHQLAPI_SUBSCRIPTION_PATH


const setupSubscription = (
  operation,
  variables,
  accessToken,
) => {
  const wsClient = createClient({
    url: GRAPHQLAPI_SUBSCRIPTION_PATH,
    // connectionParams: () => {
    //   return {
    //     Authorization: `Bearer ${accessToken}`
    //   }
    // }
  })
  return Observable.create((sink) => {
    return wsClient.subscribe(
      {
        operationName: operation.name,
        query: operation.text,
        variables,
      },
      sink,
    )
  })
  // const query = config.text
  // const { onNext, onError, onCompleted } = observer
  // const subscriptionClient = new SubscriptionClient(
  //   GRAPHQLAPI_SUBSCRIPTION_PATH,
  //   {
  //     reconnect: true,
  //     connectionParams: {
  //     }
  //   },
  // )
  // const client = subscriptionClient
  //   .request({ query, variables })
  //   .subscribe(onNext, onError, onCompleted)

  // subscriptionClient.maxConnectTimeGenerator.duration = () => subscriptionClient.maxConnectTimeGenerator.max

  // return {
  //   dispose: client.unsubscribe
  // }
}

export const createEnvironment = ({
  url,
  payload,
  signedContext,
  accessToken,
}) => {
  const headers = {}
  if (payload && signedContext) {
    headers["X-Woztell-Payload"] = JSON.stringify(payload)
    headers["X-Woztell-SignedContext"] = signedContext
  } else if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  return new Environment({
    network: new RelayNetworkLayer([
      urlMiddleware({
        url,
        headers
      }),
      NODE_ENV === "production" ? null : loggerMiddleware()
    ], {
      subscribeFn: (...args) => setupSubscription(...args, accessToken)
    }),
    store: new Store(new RecordSource()),
  })
}

export const createMessengerEnvironment = ({
  url,
  token,
  subscriptionUrl
}) => {
  const headers = {}
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }
  console.log("headers", headers)
  return new Environment({
    configName: token,
    network: new RelayNetworkLayer([
      urlMiddleware({
        url,
        headers
      }),
      NODE_ENV === "production" ? null : loggerMiddleware()
    ], {
      subscribeFn: (...args) => setupSubscription(...args, subscriptionUrl)
    }),
    store: new Store(new RecordSource()),
  })
}

// export default new Environment({
//   network: new RelayNetworkLayer([
//     urlMiddleware({
//       credentials: "include",
//       headers: {
//       }
//     }),
//     NODE_ENV === "production" ? null : loggerMiddleware()
//   ], {
//     subscribeFn: (...args) => setupSubscription(...args, GRAPHQLAPI_SUBSCRIPTION_PATH)
//   }),
//   store: new Store(new RecordSource()),
// })